const projects = {
  "myPageModal": {
    "menuLabel": "My page menu",
    "account": {
      "editField": "Edit {{field}}",
      "saveField": "Save {{field}}",
      "cancelEdit": "Cancel editing {{field}}",
      "saving": "Saving",
      "requiredError": "Please enter a value.",
      "phoneError": "Invalid phone number format.",
      "emptyValue": "No value"
    },
    "logout": {
      "message": "Do you want to log out?",
      "signingOut": "Logging out"
    },
    "withdrawal": {
      "description": "Please review the notice below and agree.",
      "processing": "Processing",
      "ownedProjectNotice": "You cannot close your account while you own a project. Please delete the project or transfer its ownership to another member first.",
      "retentionNotice": "When you close your account, your account information such as your name and email address is deleted immediately and cannot be recovered. Issues, comments, photos, and measurement records you left in projects stay in those projects for the other members, with the author shown as \"{{unknownLabel}}\".",
      "retryNotice": "Your account data has been deleted, but removing the sign-in account did not finish. Please press {{confirmLabel}} once more to complete it."
    },
    "permission": {
      "members": "Members",
      "memberList": "Member list",
      "roleGroup": "{{name}} permission",
      "deleteMember": "Delete {{name}}",
      "noChanges": "No changes",
      "changeCount": "{{count}} changes",
      "noMembers": "No members",
      "deleteTitle": "Delete member",
      "deleteMessage": "Delete member '{{name}}'?",
      "deleteSubMessage": "Deleted members cannot be restored",
      "emailLabel": "Email",
      "emailRequired": "Please enter an email.",
      "emailInvalid": "Invalid email format. Please check again.",
      "emailExists": "Email already exists.",
      "serverError": "Server error. Please contact the administrator.",
      "adding": "Adding",
      "resetDone": "Changes have been reset.",
      "noOwnProjectTitle": "You have no projects registered as owner",
      "noOwnProjectDescription": "Only owners can manage project permissions.",
      "transfer": {
        "title": "Transfer ownership",
        "warning": "Once transferred, the new owner takes over this project and you are removed from it. This cannot be undone.",
        "emailLabel": "New owner's email",
        "submit": "Transfer",
        "transferring": "Transferring",
        "notFound": "No registered user has this email (unregistered or closed), or you no longer own this project.",
        "titleConflict": "The new owner already has a project with this name, so it cannot be transferred. Rename the project and try again.",
        "invalidTarget": "You cannot transfer to yourself or to an administrator account, or the request is invalid.",
        "failed": "Failed to transfer ownership. Please try again later."
      }
    },
    "select": {
      "noResult": "No results found"
    },
    "history": {
      "timeline": "Project history",
      "loadingMore": "Loading"
    }
  },
  "queryState": {
    "projectListLoadFailed": "Failed to load the project list",
    "ownProjectListLoadFailed": "Failed to load your owned projects",
    "memberListLoadFailed": "Failed to load the member list",
    "droneImageListLoadFailed": "Failed to load the drone image list",
    "droneImageSizeLoadFailed": "Failed to load the original drone image sizes",
    "gcpFileLoadFailed": "Failed to load GCP file info",
    "layerDataLoadFailed": "Failed to load the file list",
    "layerDataLoadFailedNamed": "Failed to load the {{name}} file list",
    "drawingListLoadFailed": "Failed to load the drawing list",
    "drawingListLoadFailedNamed": "Failed to load the {{name}} list",
    "orthomosaicImageLoadFailed": "Failed to load the orthomosaic preview",
    "earthworkZoneListLoadFailed": "Failed to load the calculation zone list",
    "earthworkSurfaceListLoadFailed": "Failed to load the drawing and design surface list",
    "earthworkSurfaceNameLoadFailed": "Failed to load surface names",
    "earthworkEpochListLoadFailed": "Failed to load the time series list",
    "earthworkPermissionLoadFailed": "Failed to load project permission info",
    "earthworkPermissionChecking": "Checking project permission",
    "earthworkProjectLoadFailed": "Failed to load project info",
    "earthworkResultLoadFailed": "Failed to load the earthwork calculation result",
    "earthworkStartFailed": "Failed to start the earthwork calculation",
  },
  "earthwork": {
    "noSiteDrawingTitle": "This project has no drawings for area-based earthwork",
    "noSiteDrawingHint": "Once drawings are designated for area-based earthwork and finish converting, refresh the page to see them here.",
    "computeUnavailable": "Earthwork volumes cannot be calculated because there are no drawings for area-based earthwork.",
    "sidebarDisabled": {
      "noEarthworkSource": "Can't open: this project has no area-based earthwork drawings or line layers",
      "sourceUnreadable": "Can't open: failed to load the drawing or layer list",
      "needsCompletedTimeSeries": "Select a completed time series to open",
      "timeSeriesUnreadable": "Can't open: failed to load the time series list",
      "checking": "Checking whether this can be opened",
      "meshNotBuilt": "Can't open: the 3D mesh hasn't been built yet",
      "twoDNotBuilt": "Can't open: the 2D outputs (orthomosaic · DEM) haven't been built yet"
    }
  },
  "drawingBundle": {
    "expand": "Expand bundle",
    "collapse": "Collapse bundle",
    "memberCount": "{{count}} drawings",
    "expanding": "Unpacking bundle",
    "failed": "Bundle unpack failed",
    "pending": "{{count}} awaiting conversion",
    "uploaded": "Bundle {{name}} uploaded — {{count}} drawings registered; they appear inside the bundle once converted",
    "uploadFailed": "Bundle {{name}} upload failed — {{reason}}",
    "nameInput": "Bundle name input"
  },
  "drawingPair": {
    "title": "Upload drawings",
    "hint": "Each drawing needs exactly one alignment DXF.",
    "drawingColumn": "Drawing",
    "alignmentColumn": "Alignment DXF",
    "alignmentMissing": "No alignment DXF",
    "pickAlignment": "Choose alignment DXF for {{name}}",
    "pick": "Choose",
    "replace": "Change",
    "unpairedCount": "{{count}} drawings without an alignment DXF",
    "orphanNotice": "Unmatched DXF: {{names}}",
    "submit": "Upload",
    "submitLabel": "Upload drawing pairs",
    "submitBlockedLabel": "{{count}} drawings have no alignment DXF — upload is blocked",
    "cancel": "Cancel",
    "close": "Close",
    "dwgRequired": "No drawing (.dwg) file selected. Choose the drawing together with its alignment DXF.",
    "lonelyDxfSkipped": "{{count}} DXF file(s) without a matching drawing (.dwg) were not uploaded.",
    "alignmentUploadFailed": "Alignment DXF upload failed — {{names}}",
    "gapTitle": "{{count}} drawings left without an alignment",
    "gapDescription": "The drawings were uploaded but their alignment DXF is empty. A drawing without an alignment cannot be built.",
    "retry": "Retry alignment upload",
    "retryLabel": "Retry alignment DXF upload"
  },
  "sidebar": {
    "timeSeries": "Time Series Inspection",
    "calendar": "Calendar",
    "road": "Road Pavement",
    "graph": "Graph",
    "ship": "Ship"
  },
  "menu": {
    "timeSeries": "Time Series Inspection",
    "roadDetection": "Road Pavement Issue Detection"
  },
  "dashboard": {
    "title": "Projects",
    "searchPlaceholder": "Search projects",
    "noProjects": "No projects",
    "noSearchedTags": "No matching tags",
    "loading": "Loading...",
    "countLoading": "Checking count",
    "filterApplied": "Filter, {{count}} applied",
    "tagFilter": "Tag filter"
  },
  "modal": {
    "addProject": "Add Project",
    "editTimeSeries": "Edit Time Series",
    "editProject": "Edit Project Information",
    "steps": {
      "location": "Location",
      "projectInfo": "Project info",
      "addTimeSeries": "Add Time Series"
    },
    "projectName": "Project Name",
    "projectNamePlaceholder": "Enter project name",
    "address": "Address",
    "location": "Location",
    "changeLocation": "Change",
    "addressSearchPlaceholder": "Search an address or click the map",
    "infraType": "Infrastructure Type",
    "infraTypeInputPlaceholder": "Enter infrastructure type",
    "objectType": "Object Type",
    "selectPlaceholder": "Select",
    "objectTypeExample": "e.g. Bridge",
    "tags": "Tags",
    "tagsPlaceholder": "Select tags or add new (Enter)",
    "memo": "Memo",
    "memoPlaceholder": "Enter memo",
    "datePlaceholder": "Select date",
    "comment": "Comment",
    "commentPlaceholder": "Enter comment",
    "required": "&#42;",
    "cancel": "Cancel",
    "next": "Next",
    "previous": "Previous",
    "save": "Save",
    "add": "Add",
    "apply": "Apply",
    "feedback": {
      "projectCreated": "Project created successfully",
      "projectCreateFailed": "Failed to create project",
      "duplicateProjectName": "A project with the same name already exists.",
      "timeSeriesOwnerOnly": "Only the project owner can add or edit time series."
    },
    "state": {
      "addressSearchFailed": "Failed to load address search results",
      "addressNoResult": "No results found",
      "projectInfoLoadFailed": "Failed to load project info",
      "timeSeriesInfoLoadFailed": "Failed to load time series info"
    },
    "a11y": {
      "stepProgress": "Progress steps",
      "reselectInfraType": "Reselect infrastructure type",
      "removeTag": "Remove tag {{tag}}",
      "adding": "Adding",
      "saving": "Saving",
      "addressSearching": "Searching address",
      "addressResults": "Address search results",
      "tagsLoading": "Loading tags",
      "tagList": "Tag list",
      "projectInfoLoading": "Loading project info",
      "timeSeriesInfoLoading": "Loading time series info"
    }
  },
  "table": {
    "columns": {
      "name": "Project Name",
      "location": "Location",
      "date": "Date",
      "status": "Status",
      "actions": "Actions",
      "memo": "Memo",
      "mappingStatus": "Image Mapping Status",
      "timeSeriesCount": "Time Series"
    },
    "status": {
      "completed": "Completed",
      "processing": "Processing",
      "pending": "Pending",
      "failed": "Failed"
    },
    "addTimeSeries": "Add Time Series",
    "createNewProject": "Create a new project.",
    "lastModified": "Last Modified",
    "memoSearch": "Search Memo",
    "noMemoResults": "No memos found",
    "noSearchResult": "No results found",
    "listLoading": "Loading project list",
    "searching": "Searching"
  },
  "details": {
    "title": "Project Details",
    "information": "Project Information",
    "timeSeries": "Time Series Data",
    "noData": "No data available",
    "projectName": "Project Name",
    "location": "Location",
    "createdAt": "Created At",
    "updatedAt": "Updated At",
    "description": "Description",
    "unknown": "Unknown"
  },
  "map": {
    "title": "Project Location",
    "noLocation": "No location information",
    "preview": "Location Preview"
  },
  "tabs": {
    "information": "Information",
    "droneImage": "Drone Images",
    "layerData": "Layer Data",
    "terrainData": "Terrain Elevation Data",
    "referenceData": "Reference Data"
  },
  "information": {
    "details": "Details",
    "edit": "Edit",
    "address": "Address",
    "coordinates": "Coordinates",
    "latitude": "Latitude",
    "longitude": "Longitude",
    "infraType": "Infrastructure/Object Type",
    "tags": "Tags",
    "memo": "Memo",
    "thumbnail": "Thumbnail",
    "noImage": "No image",
    "noPreviewTarget": "No time series to load a preview from"
  },
  "layerTypes": {
    "stratum": "Stratum",
    "designHeight": "Design Height",
    "designProfile": "Original Ground Level",
    "drawing": "Drawing"
  },
  "dataTypes": {
    "image": "Images",
    "document": "Documents",
    "video": "Videos",
    "gis": "GIS",
    "line": "Line Layer",
    "bim": "BIM",
    "pointCloud": "Point Cloud"
  },
  "droneImage": {
    "selectAll": "Select All",
    "uploadedImages": "Uploaded Images",
    "uploadingImages": "Uploading Images",
    "targetImages": "Target Images",
    "totalSize": "Total Size",
    "uploadImages": "Upload Images",
    "uploadImagesCount": "Upload Images",
    "uploading": "Uploading",
    "uploadingMessage": "Please stay on this page until upload is complete",
    "uploadSuccess": "Images uploaded successfully.",
    "uploadFailed": "Failed to upload images.",
    "deleteSuccess": "Images deleted successfully.",
    "deleteFailed": "Failed to delete images.",
    "deleting": "Deleting...",
    "loading": "Loading...",
    "noValidImages": "No valid image files (.jpg, .jpeg) found.",
    "addImagesGuide": "Add images from the Add Images tab"
  },
  "file": {
    "download": "Download",
    "delete": "Delete",
    "upload": "Upload",
    "refresh": "Refresh",
    "downloadNamed": "Download {{name}}",
    "deleteNamed": "Delete {{name}}",
    "uploadNamed": "Upload {{name}}",
    "previewNamed": "Preview {{name}}",
    "deleteSuccess": "Files deleted successfully.",
    "deleteFailed": "Failed to delete files.",
    "downloadFailed": "Failed to download files.",
    "uploading": "Uploading",
    "uploadingMessage": "Please stay on this page until upload is complete",
    "skippedUnsupported": "Skipped {{count}} file(s) in unsupported formats."
  },
  "layerRename": {
    "renameLayer": "Rename",
    "renameLayerNamed": "Rename {{name}}",
    "layerNameInput": "Layer name input",
    "renameDuplicate": "This name is already in use. Please enter a different name.",
    "renameInvalid": "Invalid name. Names must be 1–100 characters.",
    "renameNoPermission": "You don't have permission to rename this layer, or it no longer exists.",
    "renameFailed": "Failed to rename the layer."
  },
  "timeSeries": {
    "mappingInfo": "Mapping Information",
    "imageMapping": "Image Mapping",
    "mappingRequest": "Request Mapping",
    "requestCompleted": "Request Completed",
    "gcpUpload": "GCP Upload",
    "gcp": "GCP",
    "gcpAutoDetect": "Auto-detect",
    "gcpAutoDetectHint": "Turn this on when the GCPs use DroneSquare standard markers. You can turn it on after uploading a GCP file.",
    "gcpAutoDetectSaveFailed": "Failed to change the GCP auto-detect setting.",
    "gcpAutoDetectBlocked": {
      "GCP_FILE_UNREADABLE": "Auto-detect can't read $t(timeSeries.gcpGuide.unreadableFormats) files. Save the file as csv or xlsx and upload it again.",
      "NO_PHOTOS": "You can turn on auto-detect after uploading drone photos."
    },
    "gcpFilesUsedTogether": "If there are several GCP files, all of them are used together.",
    "autoBuild": {
      "inProgressTitle": "Processing automatically",
      "phase": {
        "waiting": "1/3 Waiting — waiting for the processing server's turn.",
        "processing": "2/3 Processing — receiving the photos and GCPs and building results.",
        "publishing": "3/3 Publishing — uploading the results."
      },
      "phaseUnknown": "Processing with auto-build.",
      "completed": "Completed by auto-build",
      "handedOverTitle": "Our staff will process this instead of auto-build",
      "reasonUnknown": "Our staff will continue the processing.",
      "reasons": {
        "markers": {
          "what": "Not enough markers were found, or the markers did not cover the flight area evenly.",
          "nextTime": "Next time, fly low enough for a GSD of {{gcpGsdLimitCm}} cm or less, and place 6 or more markers (at least 5) in shadow-free spots, spread evenly to the corners of the flight area. List only the points where you laid markers in the GCP file."
        },
        "gcp_file": {
          "what": "The GCP file could not be read, or its coordinates did not match the flight area.",
          "nextTime": "Next time, upload a $t(timeSeries.gcpGuide.readableFormats) file with label, X, Y, Z on each line, in EPSG:5185–5188 coordinates."
        },
        "photos": {
          "what": "The photos did not meet the auto-build conditions.",
          "nextTime": "Next time, fly an allowed aircraft ($t(timeSeries.gcpGuide.allowedAircraft)) with RTK fixed, using a single wide-angle RGB camera, with at least 65% forward and 60% side overlap."
        },
        "accuracy": {
          "what": "The matching result did not meet the accuracy limits.",
          "nextTime": "Next time, check that you surveyed the marker centers and that heights are orthometric heights (KNGeoid)."
        },
        "internal": {
          "what": "Auto-build could not finish because of the processing server.",
          "nextTime": "Next time, you can keep using auto-detect as is."
        }
      }
    },
    "autoBuildRejected": {
      "AUTO_BUILD_UNAVAILABLE": "Auto-build is not used in this environment.",
      "AUTO_DETECT_OFF": "Auto-detect is off, so auto-build can't be requested. Turn on [$t(timeSeries.gcpAutoDetect)] in the GCP row and request again.",
      "GCP_FILE_MISSING": "There is no GCP file, so auto-build can't be used. Upload a GCP file in the GCP row.",
      "GCP_FILE_UNREADABLE": "There is a GCP file that auto-build can't read. Save it as $t(timeSeries.gcpGuide.readableFormats) and upload it again.",
      "NO_PHOTOS": "There are no drone photos, so auto-build can't be used.",
      "AUTO_DETECT_LOCKED": "Auto-detect can't be changed after mapping is requested.",
      "NO_RGB_PHOTOS": "There are no RGB photos that auto-build can process (only thermal or unreadable photos). Request this time series without [$t(timeSeries.gcpAutoDetect)] and our staff will process it. The shooting conditions are in the $t(timeSeries.gcpGuide.title).",
      "MULTI_SENSOR": "Photos from more than one camera are mixed, so auto-build can't be used (it accepts photos from a single wide-angle RGB camera only). Request this time series without [$t(timeSeries.gcpAutoDetect)] and our staff will process it. The shooting conditions are in the $t(timeSeries.gcpGuide.title).",
      "DRONE_UNSUPPORTED": "The photos were taken with an aircraft that auto-build doesn't support. Supported aircraft: $t(timeSeries.gcpGuide.allowedAircraft). Request this time series without [$t(timeSeries.gcpAutoDetect)] and our staff will process it. The shooting conditions are in the $t(timeSeries.gcpGuide.title).",
      "NO_GNSS": "Some photos have no GNSS position in their EXIF, so auto-build can't be used. Request this time series without [$t(timeSeries.gcpAutoDetect)] and our staff will process it. The shooting conditions are in the $t(timeSeries.gcpGuide.title).",
      "RTK_NOT_FIXED": "Some photos were not taken with RTK fixed, so auto-build can't be used. Request this time series without [$t(timeSeries.gcpAutoDetect)] and our staff will process it. The shooting conditions are in the $t(timeSeries.gcpGuide.title)."
    },
    "autoBuildRejectedUnknown": "Auto-build can't be used for this data. Request it without [$t(timeSeries.gcpAutoDetect)] and our staff will process it.",
    "mappingRequestResult": {
      "succeeded": "The mapping request has been submitted.",
      "alreadyRequested": "Mapping has already been requested or is being processed for this time series.",
      "failed": "The mapping request failed."
    },
    "mappingAutoBuildNotice": "GCP auto-detect is on, so mapping will proceed automatically.",
    "mappingRequestModal": {
      "title": "Request image mapping?",
      "description": "Once mapping is requested, you can't delete images from the image list or upload more images.",
      "confirm": "Request",
      "autoBuildConditions": "If any of the conditions below isn't met, our staff processes the data instead, which takes longer.",
      "turnOnAutoDetect": "If you laid DroneSquare standard markers before flying, turn on [$t(timeSeries.gcpAutoDetect)] in the GCP row before you request.",
      "manualThisTime": "Our staff will process this request."
    },
    "gcpGuide": {
      "open": "$t(timeSeries.gcpGuide.title)",
      "title": "GCP Auto-detect Guide",
      "aircraft": {
        "m3e": "Mavic 3E",
        "m4": "Matrice 4E/4D",
        "p4rtk": "Phantom 4 RTK",
        "p1_35": "Zenmuse P1 35 mm"
      },
      "allowedAircraft": "$t(timeSeries.gcpGuide.aircraft.m3e), $t(timeSeries.gcpGuide.aircraft.m4), $t(timeSeries.gcpGuide.aircraft.p4rtk), $t(timeSeries.gcpGuide.aircraft.p1_35)",
      "readableFormats": "csv, txt or xlsx",
      "unreadableFormats": "xls",
      "what": {
        "title": "What is auto-detect?",
        "items": [
          "If you lay DroneSquare standard markers at your GCP locations before flying, the system finds them in the photos and matches the GCPs automatically. You don't need to mark GCPs in each photo."
        ]
      },
      "checklist": {
        "title": "Conditions for automatic processing",
        "items": [
          "Lay at least 5 DroneSquare standard markers ({{gcpMarkerSideCm}} cm a side) spread evenly, and survey each marker's center on the day you lay it.",
          "Fly a DJI RTK aircraft ($t(timeSeries.gcpGuide.allowedAircraft)) with RTK fixed, using one wide-angle RGB camera.",
          "Fly at a ground sampling distance (GSD) of {{gcpGsdLimitCm}} cm or less.",
          "In the GCP file ($t(timeSeries.gcpGuide.readableFormats)), list only the points where you laid markers this time.",
          "Write heights (Z) as orthometric heights (KNGeoid)."
        ]
      },
      "prepare": {
        "title": "Preparing the markers",
        "printFile": "Print at 100% scale so the marker is {{gcpMarkerSideMm}} × {{gcpMarkerSideMm}} mm at the trim line.",
        "previewAlt": "Preview of the DroneSquare standard marker — a square 2×2 black-and-white checker plate, black at the top left and bottom right",
        "downloadPdf": "Download PDF",
        "downloadSvg": "Download SVG",
        "downloadA1": "Download A1 tile PDF",
        "a1Note": "This file prints the marker on two A1 sheets that you join together.",
        "items": [
          "The marker is a black-and-white 2×2 checker, {{gcpMarkerSideCm}} cm a side. The top-left and bottom-right squares are black, with no border and no numbers. Matte is recommended.",
          "You can also use a ready-made {{gcpMarkerSideCm}} cm plate with the same pattern. Plates with a border, numbers or a different pattern can't be used.",
          "To make your own, print it on a matte banner and add grommets at the four corners. Prepare one for each GCP."
        ]
      },
      "install": {
        "title": "Installing and surveying",
        "items": [
          "On the day you lay a marker, survey its center (the point where the two black squares meet).",
          "Lay it flat, fix the four corners, and place it where there's no water, dust or shadow.",
          "Place 6 or more (at least 5) evenly out to the corners of the flight area. If the area the markers enclose is less than 30% of the flight area, automatic processing doesn't run.",
          "(Optional) To add check points, list control points as GCP1, GCP2… and check points as CP1, CP2… in the GCP file."
        ]
      },
      "flight": {
        "title": "Flying",
        "itemsBeforeTable": [
          "Fly at a GSD of {{gcpGsdLimitCm}} cm or less. Above {{gcpGsdFalloffCm}} cm, the markers are hard to find, and the request is likely to go to our staff."
        ],
        "tableCaption": "Approximate height for a GSD of {{gcpGsdLimitCm}} cm (above ground; check the GSD in your flight app)",
        "tableHeaders": {
          "aircraft": "Aircraft",
          "altitude": "Height above ground"
        },
        "tableRows": {
          "m3e": "$t(timeSeries.gcpGuide.aircraft.m3e) · $t(timeSeries.gcpGuide.aircraft.m4)",
          "p4rtk": "$t(timeSeries.gcpGuide.aircraft.p4rtk)",
          "p1_35": "$t(timeSeries.gcpGuide.aircraft.p1_35)"
        },
        "tableAltitude": "about {{meters}} m",
        "validatedRangeNote": "{{aircraft}}: validated up to {{meters}} m.",
        "itemsAfterTable": [
          "Use at least 65% forward and 60% side overlap.",
          "Make sure each marker appears in full in at least 5 photos."
        ]
      },
      "upload": {
        "title": "Uploading and requesting",
        "items": [
          "Upload the photos and the GCP file as usual, turn on [$t(timeSeries.gcpAutoDetect)] in the GCP row, then request mapping.",
          "GCP files must be $t(timeSeries.gcpGuide.readableFormats) ($t(timeSeries.gcpGuide.unreadableFormats) can't be read). Write label, X, Y, Z on each line; the coordinate system is EPSG:5185–5188. X and Y can be in either order.",
          "Don't use heights based on a site TBM, the chart datum (DL) or the ellipsoid.",
          "Upload the GCP file for every time series, even if it's the same as the previous one."
        ]
      },
      "fallback": {
        "title": "When automatic processing doesn't run",
        "items": [
          "If not enough markers are found or the result doesn't meet the quality standard, our staff processes the data the usual way.",
          "The result quality is the same, and you don't need to do anything."
        ]
      }
    },
    "completionDate": "Completion Date",
    "coordinateSystem": "Output Coordinate System",
    "resolution": "Resolution (GSD)",
    "images": "Images (Optimized/Raw)",
    "download": "Download",
    "preview": "Preview",
    "orthomosaic": "Orthomosaic [TIF]",
    "pointCloud": "3D Point Cloud [LAS]",
    "mesh": "3D Mesh [OBJ]",
    "meshZip": "3D Mesh [OBJ] (.zip)",
    "dsm": "Digital Surface Model [DSM-TIF]",
    "dsmZip": "Digital Surface Model [DSM-TIF] (.zip)",
    "orthoDownload": {
      "optionsName": "Deliverable download options",
      "loadFailed": "Failed to load deliverable download options",
      "remainingOf": "Downloads left {{remaining}} / {{limit}}",
      "products": {
        "orthomosaic": "Orthomosaic",
        "dsm": "Digital Surface Model [DSM-TIF]"
      },
      "files": {
        "dsmGeotiff": "DSM GeoTIFF (.tif)"
      },
      "unavailable": "Not available",
      "unavailableNotice": "This epoch has no such file. Please contact your representative if you need it.",
      "geotiffGroup": "GeoTIFF (for GIS)",
      "cadGroup": "CAD package (for AutoCAD / Civil 3D)",
      "geotiffHelpLabel": "About GeoTIFF",
      "cadHelpLabel": "About the CAD package",
      "geotiffHelp": "The original has a high resolution, so the file is large and needs a lot of memory to open. We recommend downloading the 1/2 or 1/4 scale version that suits the resolution you need and your PC.\n\nA scaled version is generated once, when it is first requested, and this can take several minutes or more depending on the image size. Once generated it can be downloaded right away, and generating it does not use up a download.",
      "cadHelp": "A ZIP containing PNG, a world file (.pgw), a coordinate system (.prj), DXF (image, elevation points and elevation labels) and an elevation point CSV (Civil 3D COGO points). Unzip it and open the DXF: the image appears automatically at its real coordinates, so there is no need to position or scale it yourself.\n\nThe elevation of each point is the DSM. It is the surface height including buildings, trees and equipment, in orthometric metres. There are no points where the image is transparent or the DSM is empty.\n\nThe CAD package is generated once, when it is first requested, and this can take some time.",
      "elevationSpacingNotice": "This epoch covers a wide area, so elevation points are placed every {{spacing}} m (default 5 m).",
      "optionLabel": "{{cm}} cm/px ({{variant}})",
      "variantOriginal": "original",
      "variantScaled": "1/{{scale}} scale",
      "pixels": "{{width}} × {{height}} px",
      "notGenerated": "Not generated yet",
      "generate": "Generate",
      "generateFor": "Generate: {{option}}",
      "download": "Download",
      "downloadFor": "Download: {{option}}",
      "processing": "Generating",
      "processingFor": "Generating: {{option}}",
      "processingProgress": "Generating {{progress}}%",
      "failed": "Generation failed",
      "ownerOnly": "Only the project owner and administrator accounts can download deliverables.",
      "limitExhausted": "All downloads have been used. Please contact your representative for additional downloads.",
      "notReady": "This option is not ready yet. Its status has been reloaded.",
      "concurrencyLimit": "Too many generations are in progress. Please try again later.",
      "requestFailed": "The download request failed. Please try again.",
      "confirm": {
        "title": "Confirm download",
        "largeImageWarning": "This image is about {{megapixels}} MP (over 100 million pixels). The file is very large and needs a lot of memory to open.",
        "originalSlowNotice": "Depending on your PC and the orthomosaic size, the download may be slow. If this is inconvenient, please contact us separately.",
        "largeFileWarning": "This file is {{size}}. The download will take a long time and needs that much free disk space.",
        "cancel": "Cancel",
        "download": "Download"
      }
    }
  },
  "myPage": {
    "title": "My Page",
    "logout": "Logout",
    "menu": {
      "accountInfo": "Account Information",
      "projectPermission": "Project Permission Management",
      "projectHistory": "Project History",
      "withdrawal": "Withdrawal"
    },
    "account": {
      "title": "Account Information",
      "name": "Name",
      "email": "Email",
      "organization": "Organization",
      "phone": "Phone Number",
      "field": "Field",
      "role": "Role",
      "password": "Password",
      "passwordConfirm": "Confirm Password",
      "currentPassword": "Current Password",
      "newPassword": "New Password",
      "changePassword": "Change Password",
      "save": "Save",
      "cancel": "Cancel",
      "edit": "Edit",
      "timezone": "Display Timezone",
      "timezoneAutoDetected": "(auto-detected)"
    },
    "permission": {
      "title": "Project Permission Management",
      "addUser": "Add User",
      "searchUser": "Search User",
      "userEmail": "User Email",
      "permission": "Permission",
      "role": {
        "owner": "Owner",
        "editor": "Editor",
        "viewer": "Viewer"
      },
      "status": {
        "joined": "Joined",
        "notJoined": "Not Joined"
      },
      "actions": {
        "delete": "Delete",
        "edit": "Edit",
        "add": "Add"
      },
      "table": {
        "email": "Email",
        "name": "Name",
        "permission": "Permission",
        "status": "Status",
        "actions": "Actions"
      }
    },
    "withdrawal": {
      "title": "Account Withdrawal",
      "confirm": "Withdraw",
      "cancel": "Cancel"
    },
    "messages": {
      "passwordChanged": "Password has been changed",
      "passwordChangeFailed": "Failed to change password",
      "accountUpdated": "Account information has been updated",
      "accountUpdateFailed": "Failed to update account information",
      "userAdded": "User has been added",
      "userAddFailed": "Failed to add user",
      "userDeleted": "User has been deleted",
      "userDeleteFailed": "Failed to delete user",
      "permissionUpdated": "Permission has been updated",
      "permissionUpdateFailed": "Failed to update permission",
      "accountDeleteFailed": "Failed to delete account",
      "ownerTransferred": "Ownership has been transferred",
      "confirmDelete": "Are you sure you want to delete?",
      "confirmWithdrawal": "Are you sure you want to withdraw?",
      "projectInfoUpdated": "Project information has been updated",
      "projectInfoUpdateFailed": "Failed to update project information",
      "timeSeriesUpdated": "Time series information has been updated",
      "timeSeriesUpdateFailed": "Failed to update time series information",
      "reset": "Reset"
    },
    "history": {
      "sentence": {
        "create": "{{actor}} added {{target}}",
        "register": "{{actor}} uploaded {{target}}",
        "update": "{{actor}} changed {{type}} to \"{{name}}\"",
        "delete": "{{actor}} deleted {{target}}",
        "generic": "{{actor}} · {{target}}",
        "memberWithdrawn": "{{actor}} left the project by closing their account"
      },
      "type": {
        "project": "Project",
        "time_project": "Time series",
        "member": "Member",
        "annotation": "Annotation",
        "annotation_comment": "Comment",
        "annotation_comment_image": "Comment image",
        "category": "Category",
        "vector": "3D measurement",
        "clipping": "3D section",
        "worksite_zone": "Restricted zone",
        "geolog": "GeoLog",
        "walk_session": "Walking capture",
        "layer": "Layer",
        "drawing_mesh": "Drawing",
        "folder": "Folder",
        "project_equipment": "Equipment",
        "height_profile_record": "Elevation profile section",
        "height_profile_export": "Elevation profile export"
      },
      "name": {
        "timeProject": "Shooting date {{name}}",
        "walkSession": "Session {{name}}"
      },
      "timeProjectFallback": "Time series #{{id}}",
      "empty": "No records",
      "emptyFiltered": "No records of this type",
      "noProject": "You are not a member of any project",
      "forbidden": "You do not have permission to view this project's history",
      "error": "Failed to load history",
      "retry": "Retry",
      "loadMore": "Load more"
    }
  },
  "fileList": {
    "dragAndDrop": "Drag and drop files here",
    "or": "or",
    "selectFile": "Select File"
  },
  "status": {
    "before": "Before",
    "requested": "Requested",
    "onProcessing": "Processing",
    "failed": "Failed",
    "reviewing": "Reviewing",
    "completed": "Completed",
    "completed2d": "2D completed",
    "completed3d": "3D completed"
  },
  "droneImageTabs": {
    "list": "Uploaded List",
    "add": "Add Images"
  },
  "projectPermission": {
    "selectProject": "Select Project",
    "addMember": "Add Member",
    "saveChanges": "Save",
    "resetChanges": "Reset",
    "loading": "Loading projects...",
    "transferOwner": "Transfer ownership"
  }
} as const;

export default projects;
